import { TypographyStyles } from '@/styles'
import { Text } from '@/ui'

export const Form2553Tooltip = () => (
  <div className="flex flex-col gap-2">
    <div className="flex">
      <Text variant={TypographyStyles.H3}>Form 2553</Text>
    </div>
    <div className="flex">
      <Text variant={TypographyStyles.BODY_SM}>
        You filed this form to be elected as an S Corporation for federal tax
        purposes.
      </Text>
    </div>
  </div>
)

export const CP261Tooltip = () => (
  <div className="flex flex-col gap-2">
    <div className="flex">
      <Text variant={TypographyStyles.H3}>CP261 Letter</Text>
    </div>
    <div className="flex">
      <Text variant={TypographyStyles.BODY_SM}>
        This indicates that the IRS has accepted your S Corporation election per
        Form 2553, Election by a Small Business Corporation.
      </Text>
    </div>
  </div>
)

export const IncorporationDocTooltip = () => (
  <div className="flex flex-col gap-2">
    <div className="flex">
      <Text variant={TypographyStyles.H3}>Incorporation Document</Text>
    </div>
    <div className="flex">
      <Text variant={TypographyStyles.BODY_SM}>
        These are documents you’ve filed with the state for your corporation to
        exist.
      </Text>
    </div>
  </div>
)

export const EinLetterTooltip = () => (
  <div className="flex flex-col gap-2">
    <div className="flex">
      <Text variant={TypographyStyles.H3}>EIN Letter</Text>
    </div>
    <div className="flex">
      <Text variant={TypographyStyles.BODY_SM}>
        In order to retrieve this, you can:
        <br />
        <br />
        <ul>
          <li>Request it by calling the IRS at 800-829-4933.</li>
          <li>
            Find it on your confirmation letter from the IRS, old tax returns,
            credit reports for your business or payroll documents
          </li>
        </ul>
      </Text>
    </div>
  </div>
)

export const StateRegistrationTooltip = () => (
  <div className="flex flex-col gap-2">
    <div className="flex">
      <Text variant={TypographyStyles.H3}>State Registration</Text>
    </div>
    <div className="flex">
      <Text variant={TypographyStyles.BODY_SM}>
        This is the document that shows that you’ve registered your business in
        the state where it’s physically located.
      </Text>
    </div>
  </div>
)
